<template>
  <v-app id="app">
    <v-snackbar
      :absolute="notification.absolute"
      :bottom="notification.bottom"
      :color="notification.color"
      :left="notification.left"
      :multi-line="notification.multiLine"
      :right="notification.right"
      :timeout="-1"
      :top="notification.top"
      v-model="notification.status"
    >{{ notification.message }}
      <v-icon @click="closeSnackbar()" class="white--text" right>mdi-close</v-icon>
    </v-snackbar>
    <template v-if="$auth.ready()">
      <router-view></router-view>
    </template>
    <template v-else>
      <div class="text-center mt-5">
        <v-progress-circular color="secondary" indeterminate size="80" width="3"></v-progress-circular>
      </div>
    </template>
  </v-app>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: "App",
    metaInfo() {
      return {
        title: "Connexion",
        titleTemplate: "%s - " + this.$vuetify.lang.t("$vuetify.appName")
      };
    },
    data: () => ({}),
    methods: {
      closeSnackbar() {
        this.$store.dispatch('setNotification', {
          status: false
        })
      }
    },
    computed: {
      ...mapGetters({notification: 'notification'})
    }
  };
</script>
